module.exports = __webpack_public_path__ + "static/media/achievement-big.c6729aa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/achievement-big.jpg
// module id = 133
// module chunks = 0